import React from "react"
import Select from "react-select"

import selectStyles from './selectStyles.module.scss'

const MultiSelectFilter = ({filterName, filterParams}) => {

    return (

        <div className={selectStyles.filter_wrapper}>
            <h3 className={selectStyles.filter_title}>
                {filterName}
            </h3>
            <Select
                options={filterParams['options']}
                placeholder={`Select ${filterName}`}
                isSearchable
                isMulti
                defaultValue={filterParams['values']}
                onChange={filterParams['onChange']}
            />
        </div>
    
    )

}

export default MultiSelectFilter

